<template>
  <div>
    <div class="md-layout">
      <ValidationObserver ref="loginForm"> <!-- v-slot="{ handleSubmit }" --> <!-- 이거 사용하면 validation error 때 벗어나지 못함 -->
        <!-- <form @submit.prevent="handleSubmit(managerLogin)"> --> <!-- 이거 사용하면 validation error 때 벗어나지 못함 -->
        <form @submit.prevent="managerLogin">

          <div class="md-layout-item md-size-100">
            <md-card>
              <md-card-header class="md-card-header-green" style="background: #9e032a!important;margin: 0 0px; padding: 23px;">
                <h4 class="title text-center" style="font-weight:bold;font-size: 20px;" > <!-- slot="title"-->
                 <!--<md-icon class="login_icon">login</md-icon>-->
                                             고려대학교 교우회 통합관리자 시스템
                </h4>
              </md-card-header>

              <md-card-content style="padding: 40px 40px 10px 40px;">
                <ValidationProvider name="userNo" :rules="{ required: true, regex: /^[a-zA-Z0-9]{4,8}$/, min: 4, max:8 }" v-slot="{ passed, failed }">
                  <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                    <label>아이디</label>
                    <md-input v-model="userNo" type="text"></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </ValidationProvider>

                <!-- 최소 8 자, 하나 이상의 문자와 하나의 숫자 : ^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$ -->
                <!-- 최소 8 자, 하나 이상의 문자, 하나의 숫자 및 하나의 특수 문자 : ^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$ -->
                <!-- 최소 8 자, 하나 이상의 대문자, 하나의 소문자 및 하나의 숫자 : ^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$ -->
                <!-- 최소 8~10 자, 하나 이상의 대문자, 하나의 소문자, 하나의 숫자 및 하나의 특수 문자 : ^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,10}$-->

               <ValidationProvider name="userPasswd" :rules="{required:true, regex: /^.*(?=^.{8,15}$)(?=.*\d)(?=.*[a-zA-Z]).*$/, min:8, max:15}" v-slot="{ passed, failed }">
                  <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                    <label>패스워드</label>
                    <md-input v-model="userPasswd" type="password"></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </ValidationProvider>
                
              </md-card-content>

              <md-card-actions style="border-top: 0px solid #ddd;justify-content: center;padding-bottom: 40px;">
                <md-button type="submit" class="md-default" style="background:#b89981!important;width: 87%;">로그인</md-button>
              </md-card-actions>
            </md-card>
          </div>

        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import store from "../vuex/store";
import { mapActions, mapGetters } from "vuex"; // import helper

import { extend } from "vee-validate";
import { required, min, regex, max } from "vee-validate/dist/rules";
import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

extend("required", required);
extend("min", min);
extend("max", max);
extend("regex", regex);

export default {
  name: "Login",
  created() { // 로그인 페이지로 오면 무조건 로그아웃 시킴
    this.$store.commit("logout");
    console.log(process.env.VUE_APP_URL);
  },
  components: {
    //Modal
  },
  data() {
    return {
      type: ["", "info", "success", "warning", "danger"],
      userNo: "",
      userPasswd: "",
      isClick: false
    };
  },
  methods: {
    ...mapActions(["login"]),
    async managerLogin() {
      // 요청 올 때까지 한 번만 실행되도록
      if (this.isClick) return;
      else this.isClick = true;

      let reg = /^[a-zA-Z0-9]{4,8}$/;
      if(!reg.test(this.userNo)){
        this.isShowUserInfo = false;
        let modalOptions = kuaaFnc.getSwalModaloptions({
          html: "아이디 오류입니다.<br>[문자로 시작, 최소 4 ~ 8자]"
        });
        Swal.fire(modalOptions);
        return false;
      }

      reg = /(?=.*\d{1,15})(?=.*[a-zA-Z~`!@#$%\^&*()-+=]{1,15}).{8,15}$/
      if(!reg.test(this.userPasswd)){
        this.isShowUserInfo = false;
        let modalOptions = kuaaFnc.getSwalModaloptions({
          html: "비밀번호 오류입니다.<br>[하나 이상의 문자와 하나 이상의 숫자로 최소 8 ~ 15자]"
        });
        Swal.fire(modalOptions);
        return false;
      }


      try {
        let loginResult = await this.login({
          userNo: this.userNo,
          userPasswd: this.userPasswd
        });
        console.log("결과 : " + loginResult); // 로그인 성공하면 true, 아니면 false

        if (store.getters.getIsAuth) {
          //this.$router.push({ path: "/Friendship/GetMemberList" });
          this.$router.push({ path: "/Operation/KuaaDashboard"});
        } else {
          this.isClick = false;

          if(loginResult == null){
            this.showSwal(
                "basic",
                "해당하는 계정 정보가 없거나 에러가 발생하였습니다.<br />다시 시도해 주십시오."
            );
            return false;
          }

          if(loginResult.resultMessage != null && loginResult.resultMessage != ''){
            this.showSwal(
                "basic",
                loginResult.resultMessage
            );
            return false;
          }
        }
      } catch (err) {
        //console.log(err);
      }
    },
    showSwal(type, messageStr) {
      if (type === "basic") {
        Swal.fire({
          title: messageStr,
          buttonsStyling: false,
          confirmButtonClass: "md-button md-success"
        });
      }
    },
    notifyVue(messageStr) {
      console.log("현재 메시지 : " + messageStr);

      this.$notify({
        timeout: 2500,
        message: messageStr,
        icon: "add_alert",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "success"
      });
    }
  },
};
</script>

<style lang="scss">
#swal2-title {
  font-size: 15px !important;
}
.text-center {
  text-align: center;
}
.md-layout-item {
  width: 500px;
}
.md-card-header-green {
  background-color:#b89981 !important;
  color: #FFFFFF !important;
  font-weight: bold !important;
}
#swal2-title {
  /*
  line-height: -20px !important;

  br {
    height: 1px !important;
  }
  */
}
body{background-image: url(/img/login_bg.jpg);background-size: cover}
</style>
